import { FC, lazy } from 'react';
import { UseDoVerifyMutationContextProvider } from '@/transport/components/UseDoVerifyMutationContextProvider';
import { UseReSendUserVerifyMutationContextProvider } from '@/transport/components/UseReSendUserVerifyMutationContextProvider';

const VerifyAccountPageResponsive = lazy(() => import('@/bo-kit/components/VerifyAccountPage'));

export const VerifyAccountPage: FC<{ implementation?: 'js' | 'css' }> = ({ implementation }) => (
    <UseDoVerifyMutationContextProvider>
        <UseReSendUserVerifyMutationContextProvider>
            <VerifyAccountPageResponsive implementation={implementation} />
        </UseReSendUserVerifyMutationContextProvider>
    </UseDoVerifyMutationContextProvider>
);
